import apiHandler from "../core/apiHandler";

const recoveryCodesApi = apiHandler('recovery-codes');
export default recoveryCodesApi;
